// ===========================================================================
// URLs de imagen
// ---------------------------------------------------------------------------
// En la base solo se guarda la clave del objeto (`org/.../uuid.webp`). El
// dominio publico es configuracion del despliegue, no un dato: si mañana R2
// cambia de dominio, no hay que reescribir ninguna fila.
// ===========================================================================

const BASE = (import.meta.env.VITE_CDN_BASE_URL ?? "").replace(/\/+$/, "");

/**
 * Cloudflare solo redimensiona sobre un dominio propio del plan con Images
 * activado. En un `r2.dev` de desarrollo la ruta `/cdn-cgi/image/` devuelve
 * 404, asi que se pide explicitamente y por defecto se sirve el original.
 */
const RESIZE = import.meta.env.VITE_CDN_RESIZE === "true";

/** `null` cuando no hay imagen o no hay CDN configurado: el llamador decide. */
export function mediaUrl(
  key: string | null | undefined,
  width?: number,
): string | null {
  if (!key || !BASE) return null;

  const path = key.split("/").map(encodeURIComponent).join("/");

  if (RESIZE && width) {
    return `${BASE}/cdn-cgi/image/width=${width},quality=82,format=auto/${path}`;
  }
  return `${BASE}/${path}`;
}

export const cdnConfigured = Boolean(BASE);
